
export default {
  name: 'Currency',

  props: {
    value: {
      type: [Number, String],
      default: 0
    },

    maximumDecimalPlaces: {
      type: Number,
      default: 2
    },

    currency: {
      type: String,
      default: 'GBP'
    },

    size: {
      type: String,
      default: 'md',
      validator: prop => ['xs', 'sm', 'md', 'lg'].includes(prop)
    }
  },

  computed: {
    compCurrency() {
      return this.currency ?? 'GBP'
    }
  }
}
